//@flow
import React, {useState, useEffect} from 'react';
import PinnedContent from '.';
import {IconButton, Typography, makeStyles} from '@material-ui/core';
import type {Theme} from '@material-ui/core';
import {colors} from '../../../../../../../../assets/styles/colors';
import {Close} from '@material-ui/icons';
import CustomButton from '../../../../../../../../elements/CustomButton/CustomButton';
import {TIENDADA_LINKS} from '../../../../../../../../constants';
import {
  useRealTimeMultichat,
  useRealTimeMultichatActions,
} from '../../../../../../real-time/utils';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    maxWidth: '30rem',
    padding: '1rem',
    borderRadius: '1rem',
    background: 'white',
    boxShadow: 'rgba(17, 12, 46, 0.1) 0px 0px 32px 0px',
    display: 'flex',
    flexDirection: 'column',
    gap: '.25rem',
  },
  header: {
    display: 'flex',
    gap: '.5rem',
    alignItems: 'center',
  },
  textBold: {
    fontWeight: 600,
  },
  titleText: {
    fontSize: '.8rem',
    fontWeight: 600,
    color: colors.grey700,
  },
  messageText: {
    fontSize: '.8rem',
    fontWeight: 400,
    color: colors.grey700,
  },
  buttonOptions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '.5rem',
    marginTop: '.5rem',
    // marginRight: '1rem',
  },
  optionButton: {
    fontSize: '.8rem',
    borderRadius: '.75rem',
    padding: '.5rem 1rem',
  },
}));

const RETRY_INTERVAL = 3000;

export default function RetryConnectionContent() {
  const classes = useStyles();

  const [show, setShow] = useState(true);

  const {status, connecting} = useRealTimeMultichat();
  const {retryConnection} = useRealTimeMultichatActions();

  useEffect(() => {
    if (status !== 'DISCONNECTED') return;

    const interval = setInterval(() => {
      if (status === 'DISCONNECTED') {
        retryConnection();
      }
    }, RETRY_INTERVAL);

    return () => clearInterval(interval);
  }, [retryConnection, status]);

  if (!show) return null;
  if (status !== 'DISCONNECTED') return null;

  return (
    <PinnedContent open>
      <div className={classes.root}>
        <header className={classes.header}>
          <div>
            <Typography className={classes.titleText}>
              <span role="img" aria-label="Alert">
                🚫
              </span>{' '}
              Estas desconectado
            </Typography>
            <Typography className={classes.messageText}>
              Los nuevos mensajes no se mostrarán hasta que te reconectes
            </Typography>
            <div className={classes.buttonOptions}>
              <CustomButton
                className={classes.optionButton}
                variant="contained"
                onClick={retryConnection}
                disabled={connecting}
              >
                Reconectar
              </CustomButton>
              <CustomButton
                href={TIENDADA_LINKS.customerSupport.general}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.optionButton}
                variant="text"
              >
                Soporte
              </CustomButton>
            </div>
          </div>
          <IconButton size="small" onClick={() => setShow(false)}>
            <Close fontSize="small" />
          </IconButton>
        </header>
      </div>
    </PinnedContent>
  );
}
